/**
 * Route constants for the application
 * Centralized route definitions for consistency
 */

export const ROUTES = {
  // Public routes
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  FORGOT_PASSWORD: '/forgot-password',
  BECOME_PARTNER: '/become-partner',
  BLOG: '/blog',
  BLOG_POST: '/blog/:slug',

  // Customer app routes
  CUSTOMER: {
    BASE: '/app',
    SEARCH: '/app/search',
    BIKE_DETAIL: '/app/bikes/:bikeId',
    BOOKING: '/app/booking',
    BOOKING_CONFIRM: '/app/booking/confirm',
    MY_BOOKINGS: '/app/bookings',
    PROFILE: '/app/profile',
    CART: '/app/cart',
    CHECKOUT: '/app/checkout',
    PRODUCTS: '/app/products',
    PRODUCT_DETAIL: '/app/products/:productId',
  },

  // Partner portal routes
  PARTNER: {
    BASE: '/partner',
    DASHBOARD: '/partner/dashboard',
    INVENTORY: '/partner/inventory',
    CHECK_IN: '/partner/check-in',
    CHECK_OUT: '/partner/check-out',
    MAINTENANCE: '/partner/maintenance',
    RESERVATIONS: '/partner/reservations',
    REVENUE: '/partner/revenue',
    PROFILE: '/partner/profile',
  },

  // Admin dashboard routes
  ADMIN: {
    BASE: '/admin',
    DASHBOARD: '/admin/dashboard',
    FLEET: '/admin/fleet',
    LOCATIONS: '/admin/locations',
    PARTNERS: '/admin/partners',
    ANALYTICS: '/admin/analytics',
    BOOKINGS: '/admin/bookings',
    USERS: '/admin/users',
    SETTINGS: '/admin/settings',
    PRODUCTS: '/admin/products',
    PRODUCT_NEW: '/admin/products/new',
    PRODUCT_EDIT: '/admin/products/:productId/edit',
    CMS: {
      BASE: '/admin/cms',
      HOME: '/admin/cms/home',
      LANDING_PAGES: '/admin/cms/landing-pages',
      BLOG: '/admin/cms/blog',
      BLOG_NEW: '/admin/cms/blog/new',
      BLOG_EDIT: '/admin/cms/blog/:postId',
      STORE: {
        BASE: '/admin/cms/store',
        PRODUCTS: '/admin/cms/store/products',
        BULK_UPLOAD: '/admin/cms/store/bulk-upload',
        SKUS: '/admin/cms/store/skus',
        QR_CODES: '/admin/cms/store/qr-codes',
        SHIPPING: '/admin/cms/store/shipping',
        INVENTORY: '/admin/cms/store/inventory',
      },
    },
  },
} as const;

